/**
 * The uploads a follow-up chip sends again with its prompt (PLT-7459).
 *
 * The server keeps no upload past the turn that carried it, so a chip whose
 * action needs a file's contents — creating a separate company from the files
 * the existing-company check stopped — would otherwise start a turn without
 * them. A chip the model marks `resendUploads` sends again the files of the
 * latest user message before it that carries any. Their bytes are still in the
 * thread state, which keeps what the composer read for the rest of the session.
 *
 * They go untagged, as a fresh upload: the user clicked for this, so it is not
 * the silent PLT-5558 replay (`reattached`), and neither that replay's size cap
 * nor its fund-upload gate applies. After a reload the history carries no file
 * bytes, so nothing is found and the prompt goes alone; the model then asks for
 * the files.
 *
 * Kept free of React so it can be unit-tested on its own.
 */
import type { CompleteAttachment, ThreadMessage } from '@assistant-ui/react';

export function uploadsToResend(
  messages: readonly ThreadMessage[],
  chipToolCallId: string,
): readonly CompleteAttachment[] {
  const chipIndex = messages.findIndex(
    m => m.role === 'assistant' && m.content.some(p => p.type === 'tool-call' && p.toolCallId === chipToolCallId),
  );
  for (let i = chipIndex - 1; i >= 0; i--) {
    const message = messages[i];
    if (message.role !== 'user') continue;
    const withBytes = message.attachments.filter(a => a.content.some(p => p.type === 'file' && p.data));
    if (withBytes.length > 0) return withBytes;
  }
  return [];
}
